import React, { createContext, useContext, useState } from "react";
import { validateCrmPassword } from "../services/api";
import { safeGet, safeRemove, safeSet } from "../utils/safeStorage";

const STORAGE_KEY = "hl_crm_password";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [password, setPassword] = useState(() => safeGet(STORAGE_KEY) || "");
    const isAuthenticated = !!password;

    const login = async (pw) => {
        await validateCrmPassword(pw);
        safeSet(STORAGE_KEY, pw);
        setPassword(pw);
    };

    const logout = () => {
        safeRemove(STORAGE_KEY);
        setPassword("");
    };

    return (
        <AuthContext.Provider value={{ password, isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
